module.exports = __webpack_public_path__ + "img/stefan-round.5b2151eb.png";